// Header.tsx
import Grid2 from '@mui/material/Grid2/Grid2';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuIcon from "@mui/icons-material/Menu"; // Ícono del menú hamburguesa
import CloseIcon from "@mui/icons-material/Close"; // Ícono de cerrar menú


import LoginModal from './LoginModal/LoginModal.tsx';
import { useAuth } from './Auth/AuthContext.tsx';
import UserProfileMenu from './UserProfileMenu/UserProfileMenu.tsx';

import './Header.css';

const logoMenu = require('../assets/img/logo-menu-black.png');
const lupaIcon = require('../assets/img/lupa-icon.png');

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loginOpen, setLoginOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      navigate(`/Recetas?SearchBox=${searchTerm}`);
    }
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleLoginClick = () => {
    setLoginOpen(true);
  };
  const handleCloseLogin = () => {
    setLoginOpen(false);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const alphanumericValue = value.replace(/[^a-zA-Z0-9 áéíóúÁÉÍÓÚ]/g, '');
    setSearchTerm(alphanumericValue);
  };

  return (
    <header className="App-header"> 
        <nav className="top-menu">
          <Grid2 className="menu-left">
            
            {/* Logo */}
            <Grid2 className="logo">
              <button className="logo-button" onClick={handleHomeClick}>
                <img src={logoMenu} alt="Logo" />
              </button>
            </Grid2>

            <Grid2 className="search-box">
              <Grid2 className="search-icon">
                <img src={lupaIcon} alt="Lupa" />
              </Grid2>
              <input
                className="search-input"
                type="text"
                placeholder="¿Qué te gustaría cocinar hoy?"
                value={searchTerm}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
              />
            </Grid2>
          </Grid2>
          {/* Botón del menú hamburguesa */}
          <button className="menu-toggle" onClick={toggleMenu}>
              {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          {/* Menú colapsable */}
          <Grid2 className={`menu-right ${isMenuOpen ? "open" : ""}`}>
            <Grid2 className="nav-links">
            <button className="menu-toggle" onClick={toggleMenu}>
              {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
              <a href="/Recetas">Recetas</a>
              <a href="/tips">Tips</a>
              {/*<a href="#del-chef">Del Chef</a>
              <a href="#promos">Promos</a>*/}
            </Grid2>
            {user ? (
              <UserProfileMenu avatar={user.avatar ?? ""} name={user.name} />
            ) : (
              <button className="session-button" onClick={handleLoginClick}>
                Iniciar sesión / Registrarse
              </button>
            )}
            <LoginModal open={loginOpen} onClose={handleCloseLogin} />
          </Grid2>
        </nav>
      </header>
  );
};

export default Header;
